import type { Item } from '@mas-flow/types';
import type { FilterState } from './types';

export function applyFilters(items: Item[], f: FilterState): Item[] {
  const q = f.q.trim().toLowerCase();
  const catSet = new Set(f.category);
  const lifecycleSet = new Set(f.lifecycle);
  const confidenceSet = new Set(f.confidence);
  const decisionSet = new Set<string | null>(f.decision);

  return items.filter((it) => {
    if (!f.showArchived && it.lifecycle === 'Archived') return false;
    if (f.anchorsOnly && !it.isAnchor) return false;

    if (q) {
      const hay = [
        it.title ?? '',
        it.problemStatement ?? '',
        it.desiredOutcome ?? '',
      ].join('\n').toLowerCase();
      if (!hay.includes(q)) return false;
    }

    if (catSet.size > 0 && !catSet.has(it.categoryId)) return false;
    if (lifecycleSet.size > 0 && !lifecycleSet.has(it.lifecycle)) return false;
    if (confidenceSet.size > 0 && (it.confidence === null || !confidenceSet.has(it.confidence))) return false;

    if (decisionSet.size > 0 && !decisionSet.has(it.decision)) return false;

    return true;
  });
}
